import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import styles from './Common.module.css';
import { DBSpecDropDownObjective } from '_components';

class SpecTestsLumbarManipulationTestCluster extends React.Component {

    render() {
        
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_LumbarManipulationTestCluster' name='Lumbar Manipulation Test Cluster' visible={false} flagged={this.props.flagged}>
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (
                                    <div key={this.props.panels[key].MOPNO} className={styles.dropdown_row}>
                                        <span className={styles.flag} />
                                        <span className={styles.spacer} />
                                        <label className={styles.label_wide}>{this.props.panels[key].MOPLABEL}</label>
                                        <DBSpecDropDownObjective
                                            field={this.props.panels[key].MOPCOLUMNPREFIX}
                                            noteId={this.props.noteId}
                                            entity='PTOBJECTIVESPECTESTS'
                                            entityKeyColumn='TSNO'
                                            entityKeyValue={this.props.tsno}
                                            className={styles.r}
                                            optionsValue={7}
                                        />
                                    </div>
                                );
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagCount = 0;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLMTCDURATIONLT16 === 'yes') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLMTCDISTALSYMP === 'yes') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLMTCFABQLT19 === 'yes') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLMTCSEGMOBTEST === 'yes') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSLMTCHIPINTROT === 'yes') {
        flagCount++;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'LumbarManipulationTestCluster'),
        flagged: flagCount >= 4 ? true : false
    };
}

const connectedSpecTestsLumbarManipulationTestCluster = connect(mapStateToProps)(SpecTestsLumbarManipulationTestCluster);
export { connectedSpecTestsLumbarManipulationTestCluster as SpecTestsLumbarManipulationTestCluster };



